"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/FileMessage/FilePlain.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _fileSize = require('shared/utils/fileSize');
var _message = require('shared/enum/message');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _keyboard = require('web/services/keyboard');

const withNoBubbling = (cb) => (e) => {
  e.stopPropagation()
  cb()
}












const FilePlain = ({
  deliveryStatus,
  onDownload, onRetry, onAbort,
  fileName, fileSize, canRetry = true,
}) => {
  const isLoading = deliveryStatus === _message.deliveryStatus.SENT
  const isCanceled = deliveryStatus === _message.deliveryStatus.CANCELED
  const hasFailed = deliveryStatus === _message.deliveryStatus.FAILED
  const isDelivered = deliveryStatus === _message.deliveryStatus.DELIVERED

  const fileExtension = _optionalChain([fileName, 'access', _ => _.split, 'call', _2 => _2('.'), 'access', _3 => _3.pop, 'call', _4 => _4(), 'optionalAccess', _5 => _5.toLowerCase, 'call', _6 => _6()]) || ''
  let documentType = 'other'
  if (fileExtension === 'pdf') {
    documentType = 'pdf'
  } else if (['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(fileExtension)) {
    documentType = 'office'
  }

  return (
    _react2.default.createElement('div', {
      onClick: isDelivered ? onDownload : undefined,
      className: _classBuilder2.default.call(void 0, 
        "file-message--plain",
        `file-message--plain--${documentType}`,
        isDelivered && 'file-message--plain--clickable',
        hasFailed && 'file-message--plain--failed',
      ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}

      , _react2.default.createElement('div', { className: "file-message--plain--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
        ,  fileExtension.length <= 4 ? fileExtension : null 
      )
      , _react2.default.createElement('div', { className: "file-message--plain--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}
        , _react2.default.createElement('span', { className: "file-message--plain--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}},  fileName )
        , _react2.default.createElement('span', { className: "file-message--plain--size", __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
          ,  _fileSize.getDisplaySize.call(void 0, fileSize) 
        )
      )
      ,  (isLoading || isCanceled) && (
        _react2.default.createElement('div', {
          role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
          'aria-label': "Cancel upload" ,
          onClick: withNoBubbling(onAbort),
          className: "file-message--btn file-message--btn-loading" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}
        )
      )
      ,  hasFailed && canRetry && (
        _react2.default.createElement('div', {
          role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
          'aria-label': "Retry upload" ,
          onClick: withNoBubbling(onRetry),
          className: "file-message--btn file-message--btn-retry" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}
        )
      )
      ,  isDelivered && (
        _react2.default.createElement('div', { className: "file-message--btn file-message--btn-noop" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}} )
      )
    )
  )
}

exports. default = FilePlain
